import React from 'react'
import Navbar from '../components/Navbar';
import Footer from "../components/Footer";
import HeroImg2 from "../components/HeroImg2";
import PricingCard from "../components/PricingCard";
import Work from "../components/Work";
import WhatsAppButton from '../components/WhatsAppButton';

const Project = () => {
  return (
    <div>
      <Navbar/>
      <HeroImg2 heading="PROJECTS." text="Projects carried out in different locations" />
      <Work/>
      <PricingCard/>
      <WhatsAppButton />
      <Footer/>

    </div>
  )
}

export default Project